import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { isTablet, isMobile, osName } from "react-device-detect";
import { BASE_URL } from "../../../../../../../custom_utilities/baseURL";
import { url_7 } from "../../../../../../../custom_utilities/api_services";
import "./StreamingVideo.scss";
import ChatComponent from "./chatting_box/Chatting";
import StreamingVideoDetails from "./StreamingVideoDetails";
import HeaderComponent from "../../../../../structure_components/desktop_screens/header_component/header_component";
import Sidebar from "../../../../../../../components/Sidebar/Sidebar";
import { toastifyMessage } from "../../../../../../../custom_utilities/toastify_config";
import { useHistory, useLocation } from "react-router-dom";
import VideoDrmPlayer from "../../../../../features/video_feature/video_feature_content_component/VideoDrmPlayer";
import images from "../../../../../../../utilities/images/images";

const StreamingVideo = ({
  token,
  tokenType,
  LiveVideoStreamingDetails,
  videoData,
}) => {
  const { zoomId, isLive, live_class_id, normalVideos } =
    LiveVideoStreamingDetails;

  const [streamingDetails, setStreamingDetails] = useState({});
  const [drmVideo, setDrmVideo] = useState(null);

  const history = useHistory();
  const location = useLocation();
  const isStandalonePage = location.pathname === "/streaming";

  useEffect(() => {
    if (
      !isLive &&
      Number(location.state?.vodType) === 1 &&
      location.state?.videoCryptId
    ) {
      setDrmVideo({
        ...videoData,
        video_id: location.state.videoId || videoData?.video_id,
        video_crypt_id: location.state.videoCryptId,
        vod_type: 1,
        redirectedFrom: videoData?.redirectedFrom || "activity",
        meeting_topic:
          location.state.title ||
          videoData?.meeting_topic ||
          videoData?.video_title,
      });
      return;
    }

    getStreamingDetails();
  }, []);

  const isAndroidTablet = isTablet && osName === "Android";
  const isIPad = isTablet && osName === "iOS";
  const isIPhone = isMobile && osName === "iOS";

  const checkDevice = () => {
    if (isTablet) {
      if (isAndroidTablet) {
        return "tablet";
      } else if (isIPad) {
        return "ios";
      } else {
        return "web";
      }
    } else if (isIPhone) {
      return "ios";
    } else {
      return "web";
    }
  };

  const checkIsIphone = () => {
    if (isIPhone) {
      return 1;
    } else {
      return 0;
    }
  };

  const showStreamDown = (response) => {
    toastifyMessage({
      status: response.data.status,
      message: response?.data?.message,
    });

    setTimeout(() => {
      history.push("/store");
    }, 3000);
  };

  const requestStream = (id) => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };

    return axios.post(
      `${BASE_URL}/api/streamos?id=${id}&isMobile=false&type=${
        isLive ? "Live" : "Recorded Live"
      }&device=${checkDevice()}&is_ios=${checkIsIphone()}`,
      { headers }
    );
  };

  const recoverRecordedPlayback = async (failedId) => {
    const videoId = location.state?.videoId || videoData?.video_id;
    if (isLive || !videoId) return false;

    try {
      const response = await axios.get(`${url_7}?video_id=${videoId}`);
      const detail = response?.data?.data?.VideoDetail;
      if (!detail) return false;

      const vodType = Number(detail.vod_type);
      const cryptId = detail.video_crypt_id;

      if (vodType === 1 && cryptId) {
        setDrmVideo({
          ...videoData,
          ...detail,
          redirectedFrom: videoData?.redirectedFrom || "activity",
          vod_type: 1,
          video_crypt_id: cryptId,
        });
        return true;
      }

      if (vodType === 2 && cryptId && String(cryptId) !== String(failedId)) {
        const retry = await requestStream(cryptId);
        if (retry?.data?.status === 422) return false;
        if (retry?.status === 200 && retry?.data?.data) {
          setStreamingDetails(retry.data.data);
          return true;
        }
      }
    } catch (error) {
      console.log(error);
    }

    return false;
  };

  const getStreamingDetails = async () => {
    try {
      const response = await requestStream(zoomId);

      if (response?.data?.status === 422) {
        const recovered = await recoverRecordedPlayback(zoomId);
        if (recovered) return;

        showStreamDown(response);
      } else if (response.status === 200) {
        setStreamingDetails(response.data.data);
      }
    } catch (error) {
      const failedResponse = error?.response;
      if (failedResponse?.data?.status === 422 || failedResponse?.status === 422) {
        const recovered = await recoverRecordedPlayback(zoomId);
        if (recovered) return;
        if (failedResponse?.data?.message) {
          showStreamDown(failedResponse);
          return;
        }
      }
      console.log(error);
    }
  };

  const streamBody = Object.keys(streamingDetails).length ? (
    <div
      className="live-streaming-container"
      style={
        !isStandalonePage && !normalVideos
          ? { padding: "5rem 8rem 0 8rem" }
          : undefined
      }
    >
      <StreamingVideoDetails
        streamingDetails={streamingDetails}
        isLive={isLive}
        live_class_id={live_class_id}
        videoData={videoData}
        normalVideos={normalVideos}
      />
      {isLive && (
        <ChatComponent
          streamingDetails={streamingDetails}
          live_class_id={live_class_id}
          isLive={isLive}
          videoData={videoData}
        />
      )}
    </div>
  ) : null;

  const drmBody = drmVideo?.video_crypt_id ? (
    <div className="live-streaming-container">
      <div className="video-player-container is-recorded-video">
        <div className="video-details-watch-count">
          <div className="video-details">
            <button
              type="button"
              className="streaming-back-btn"
              onClick={() => {
                const topicState = location.state?.returnToTopic || {};
                history.push({
                  pathname: "/topic_component",
                  state: {
                    ...topicState,
                    screenVersion: "new",
                    fromSubject: false,
                  },
                });
              }}
            >
              <img src={images.user_activity_back} alt="Back" />
            </button>
            <p className="streaming-heading">
              {drmVideo.meeting_topic ||
                drmVideo.video_title ||
                drmVideo.video_description}
            </p>
          </div>
        </div>
        <VideoDrmPlayer
          id_video={drmVideo.video_crypt_id}
          data={drmVideo}
          fromVideoLecture
        />
      </div>
    </div>
  ) : null;

  const playbackBody = drmBody || streamBody;

  if (isStandalonePage) {
    return (
      <div className="streaming_page_wrapper">
        <Sidebar />
        <div className="streaming_page_main">{playbackBody}</div>
      </div>
    );
  }

  return (
    <>
      {!normalVideos && <HeaderComponent />}
      {playbackBody}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userPreference: state.userPreference,
    token: state.auth.authToken,
    tokenType: state.auth.tokenType,
    LiveVideoStreamingDetails: state.LiveVideoStreamingSlice,
    videoData: state.userActivity.videoData,
  };
};

export default connect(mapStateToProps, null)(StreamingVideo);
